import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageShell } from '@/components/layout/PageShell';
import { Hero } from '@/components/landing/Hero';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { CTA } from '@/components/landing/CTA';
import { AuthModal } from '@/components/auth/AuthModal';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/lib/constants';

/**
 * Landing page. Three sections, hosted inside the PageShell.
 *
 * Signed-out visitors get the auth modal from the primary buttons; a
 * successful sign-in / sign-up from here continues straight to the
 * projects page. Signed-in visitors get "Open your projects" instead.
 *
 * Note: PageShell already hosts its own AuthModal (wired to Header's
 * Sign-in button). This second, locally-controlled instance lets the
 * Hero/CTA buttons open the dialog without lifting state into PageShell.
 */
export function LandingPage() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false);
  const signedIn = status === 'authenticated';

  const onPrimary = () => {
    if (signedIn) navigate(ROUTES.projects);
    else setAuthOpen(true);
  };

  const label = signedIn ? 'Open your projects' : 'Sign in to begin';

  return (
    <PageShell>
      <Hero onPrimaryClick={onPrimary} primaryLabel={label} />
      <HowItWorks />
      <CTA onPrimaryClick={onPrimary} primaryLabel={label} />

      <AuthModal
        open={authOpen}
        onOpenChange={setAuthOpen}
        onAuthenticated={() => navigate(ROUTES.projects)}
      />
    </PageShell>
  );
}
